import { render, staticRenderFns } from "./StaffUsers.vue?vue&type=template&id=1bef111e&scoped=true"
import script from "./StaffUsers.vue?vue&type=script&lang=js"
export * from "./StaffUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef111e",
  null
  
)

export default component.exports